export default __webpack_public_path__ + "static/media/RAMADA06.9d4b7da1.jpg";